import { datadogRum } from '@datadog/browser-rum'
import React, { FC, PropsWithChildren, useEffect } from 'react'
import { useDispatch } from 'react-redux'
import { fetch } from 'src/modules/apis/auth/ping/request'
import { Loader } from 'src/modules/components/lib/loader'
import { useIdPlatform } from 'src/modules/hooks/useIdPlatform'
import { useAccount } from '../hooks/use-account'
import { actions as authActions } from './redux'

export const LoggedInGuard: PropsWithChildren<FC> = ({ children }) => {
  const { authorized, authorizedAccount } = useAccount()
  const { redirectToLogin } = useIdPlatform()

  const dispatch = useDispatch()

  useEffect(() => {
    if (authorized) {
      return
    }

    const doPing = async () => {
      try {
        const account = await fetch()
        if (account) {
          dispatch(authActions.authorize({ account }))

          datadogRum.setUser({ id: account.uid })
        } else {
          dispatch(authActions.unauthorize())
          datadogRum.clearUser()
          redirectToLogin()
        }
      } catch (error) {
        dispatch(authActions.unauthorize())
        datadogRum.clearUser()

        // NOTE: メンテナンス中の場合は、ログイン画面にリダイレクトしない
        // @ts-ignore
        if (error?.original?.response?.status === 503) return
        redirectToLogin()
      }
    }

    doPing()
  }, [authorized, dispatch, redirectToLogin])

  if (!authorizedAccount || !authorized) {
    return <Loader />
  }

  return <>{children}</>
}
